module.exports = __webpack_public_path__ + "@/assets/img/026-boy-10.2ffeeff5.svg";